import { Payload } from 'modules/cart/types/cart';
import React from 'react';

import { ProductCard } from "modules/product/components/productCard";
import {get_total_qty_per_prod} from "utils/cartUtils";


import { useCart } from "modules/cart/hooks/useCart";



import { CursorPaginator } from "modules/catalog/components/paginator";
import { ProductCatalogSkeleton } from './product-catalog-skeleton';
import { NoAuthError } from 'modules/authentication/components/no-auth-error';
import { AuthError } from 'modules/authentication/types/form-login-types';
import { GeneralError } from 'modules/main/components/general-error';
import { filterParam } from "modules/main/services/endpoints";

import { isDesktopSize } from 'utils/is-desktop';
import { useMediaQuery } from '@/hooks/use-media-query';
import { CatalogResponse } from '../types/catalogResponse';

interface SearchResultsProps extends React.HTMLAttributes<HTMLDivElement>{
    section:string,
    brand_filters:filterParam,
    tag_filters:filterParam,
    currentPage:string | null,
    search_params:string,
    isMobile?:boolean,
    data:CatalogResponse,
    error?:any,
    loading?:boolean
    attribution_token?:string | null
    /**
     * When provided, replaces the default addDeletefromCart callback in every
     * ProductCard. Useful for embedded pickers (e.g. ProductSearchPicker) that
     * need to intercept the "add" action.
     */
    overrideAddCallback?: (payload: Payload) => void;
    /** Optional callback for client-side page navigation. When provided, renders buttons instead of anchors. */
    onNavigate?: (nextCursor: string | null, prevCursor: string | null) => void;
} 


export const SearchResults = React.forwardRef<HTMLDivElement,SearchResultsProps>(({
    className,
    // cart,
    // data,
    section,
    brand_filters,
    tag_filters,
    // cartModifyCallback,
    // recalculateCallBack,
    // pages,
    currentPage,
    search_params,
    data,
    overrideAddCallback,
    onNavigate,
    ...props},ref) => {
        
    const isDesktop = useMediaQuery(isDesktopSize);
    
    const {addDeletefromCart,recalculatePrice,validating, cart} = useCart();


    const ErrorComponent = (props?.error instanceof AuthError) ? NoAuthError : GeneralError;

    return (           
        <>
        {(props.error)&&(<ErrorComponent/>)}
        {(props.loading)&&(<ProductCatalogSkeleton isMobile={props.isMobile}/>)}
        {(!props.loading && !props.error) &&    
        <div className="flex flex-col flex-1 p-2 text-sm gap-4">
            <div className="flex flex-row flex-wrap gap-8"> 
                {
                data?.products?.map( (product, index) => {                        
                    return (
                        <ProductCard  key={index} 
                            product={product} 
                            addCallback={overrideAddCallback ?? addDeletefromCart} 
                            recalculateCallBack={overrideAddCallback ? () => {} : recalculatePrice}
                            validatingCallBack={overrideAddCallback ? (_payload: Payload) => Promise.resolve({ isOpen: false }) : validating}
                            inCart={get_total_qty_per_prod(product.id,cart)}
                            isDesktop={isDesktop}
                            attribution_token={props.attribution_token}
                            />
                    );
                })}                        
                {
                (data?.products?.length === 0) && <div>No se encontraron productos para la búsqueda de:  {section}</div>
                }
            </div>
            <CursorPaginator search_params={search_params} current={currentPage} next={data?.next_page??null} onNavigate={onNavigate} />
        </div>    
        }
        </>  
    );
})